import { STATE_NAME } from './constants';
import reducer from './reducer';
import SearchRoot from './containers/SearchRoot';

export default function initPage(store) {
  store.injectAsyncReducer(STATE_NAME, reducer);

  return SearchRoot;
}
